// Shared label maps for Indonesian school taxonomy.
export const TYPE_LABELS = {
  negeri: "Negeri",
  swasta: "Swasta",
  mi: "MI (Madrasah Ibtidaiyah)",
  mts: "MTs (Madrasah Tsanawiyah)",
  ma: "MA (Madrasah Aliyah)",
  pesantren: "Pesantren",
  spk: "SPK (Satuan Pendidikan Kerja Sama)",
  internasional: "Internasional",
  islam: "Islam", // legacy
};

export const TYPE_LABELS_SHORT = {
  negeri: "Negeri",
  swasta: "Swasta",
  mi: "MI",
  mts: "MTs",
  ma: "MA",
  pesantren: "Pesantren",
  spk: "SPK",
  internasional: "Internasional",
  islam: "Islam",
};

export const TYPE_OPTIONS = [
  { value: "negeri", label: "Negeri" },
  { value: "swasta", label: "Swasta" },
  { value: "mi", label: "MI (Madrasah Ibtidaiyah)" },
  { value: "mts", label: "MTs (Madrasah Tsanawiyah)" },
  { value: "ma", label: "MA (Madrasah Aliyah)" },
  { value: "pesantren", label: "Pesantren" },
  { value: "spk", label: "SPK (Satuan Pendidikan Kerja Sama)" },
  { value: "internasional", label: "Internasional" },
];

// Short labels for pills, chips, filters. Long labels used on school profile.
export const GRADE_LABELS = { kb: "KB", tk: "TK", sd: "SD", smp: "SMP", sma: "SMA" };

export const GRADE_LABELS_LONG = {
  kb: "Kelompok Bermain (KB)",
  tk: "Taman Kanak-Kanak (TK)",
  sd: "SD",
  smp: "SMP",
  sma: "SMA",
};

// Segment enum (iter152) — groups jenjang for aggregations & analytics.
// KB + TK share EARLY_CHILDHOOD; individual jenjang stays intact in the DB.
export const GRADE_SEGMENTS = {
  kb: "EARLY_CHILDHOOD",
  tk: "EARLY_CHILDHOOD",
  sd: "PRIMARY",
  smp: "MIDDLE",
  sma: "HIGH",
};

export const GRADE_OPTIONS = [
  { value: "kb", label: "KB", helper: "Kelompok Bermain" },
  { value: "tk", label: "TK" },
  { value: "sd", label: "SD" },
  { value: "smp", label: "SMP" },
  { value: "sma", label: "SMA" },
];


// Curriculum options for admin school form (multi-select checkboxes).
// Canonical curriculum taxonomy — mirrors the backend's `curriculum` array
// values and the Directory filter chips. `Lainnya` is a first-class canonical
// value that flags "off-list" curricula; free-text specifics live in the
// separate `curriculum_detail` field, NOT inside this array.
export const CURRICULUM_OPTIONS = [
  { value: "Kurikulum Merdeka", label: "Kurikulum Merdeka" },
  { value: "Kurikulum 2013/K13", label: "Kurikulum 2013/K13" },
  { value: "Cambridge", label: "Cambridge" },
  { value: "International Baccalaureate (IB)", label: "International Baccalaureate (IB)" },
  { value: "Advanced Placement (AP)", label: "Advanced Placement (AP)" },
  { value: "English National Curriculum", label: "English National Curriculum" },
  { value: "International Primary Curriculum (IPC)", label: "International Primary Curriculum (IPC)" },
  { value: "Singapore Curriculum", label: "Singapore Curriculum" },
  { value: "Pearson Edexcel", label: "Pearson Edexcel" },
  { value: "Australian Curriculum", label: "Australian Curriculum" },
  { value: "New Zealand Curriculum", label: "New Zealand Curriculum" },
  { value: "Montessori", label: "Montessori" },
  { value: "Kurikulum Keagamaan", label: "Kurikulum Keagamaan" },
  { value: "Kurikulum Sekolah/Proprietary", label: "Kurikulum Sekolah/Proprietary" },
  { value: "Lainnya", label: "Lainnya" },
];

export const CURRICULUM_STANDARD_VALUES = CURRICULUM_OPTIONS.map((o) => o.value);

// Branch education levels (education_levels field). Values stored uppercase.
export const EDU_LEVEL_OPTIONS = [
  { value: "TK", label: "TK" },
  { value: "SD", label: "SD" },
  { value: "SMP", label: "SMP" },
  { value: "SMA", label: "SMA" },
];


// Religion affiliation options (used for religion filter + admin form).
export const RELIGION_OPTIONS = [
  { value: "islam", label: "Islam" },
  { value: "kristen", label: "Kristen" },
  { value: "katolik", label: "Katolik" },
  { value: "budha", label: "Budha" },
  { value: "hindu", label: "Hindu" },
  { value: "umum", label: "Umum" },
];

export const RELIGION_LABEL = Object.fromEntries(RELIGION_OPTIONS.map((r) => [r.value, r.label]));
